module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAQlBMVEUXF5YbG5geHpkmJp0pJowxLpA1NaRBQalHR6xOTq9SUrFeXrZhYbh0ZGF0dMCdhkq1td7Hx+XPsC3d3fD30Rf///9HYlPNAAAAaklEQVR42oXPSQqAMBAF0TjPU6L3v6oBwUJc1N81PBoqPNv30Nbx/G0L3xVlNR9TExXmrdca8k+HYzf2PRL435DSkKVAigxSZJAigxQZpMggRQYpMkiRQoqAUgS0IqAVAa0IaEVAKVre8wbHrxPRixUnnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ba.png
// module id = 776
// module chunks = 0